/**
 * Componente per la gestione dell'inserimento dei valori relativi alla fatturazione
 * Sotto alla lista dei prodotti nel carrello, sono presenti alcuni campi relativi alla fatturazione Italiana (SDI).
 * Se una persona vuole acquistare come azienda, dovrà utilizzare questi campi che diventeranno obbligatori.
 * Se una persona acquista come privato, questi campi saranno nascosti e saranno facoltativi.
 */
class CartBillableFields extends HTMLElement {
    // Costruttore
    constructor() {
        // Chiamo la super classe per accedere alle proprietà dell'HTMLElement
        super();      
        // Gestione della visualizzazione di campi billable
        this.showHideCartBillableFields();                
        // Aggiunta dell'attributo custom nel carrello del campo SDI
        this.addAttributesCartSDI();        
    }

    // Metodo per la gestione della visualizzazione dei campi billable
    showHideCartBillableFields() {
        // Div contenitore per i campi della fatturazione
        var cntCartBillableFields = document.getElementById('cnt_billable_cart_fields');
        // Checkbox per visualizzare o nascondere i campi relativi alla fatturazione
        var checkIsAzienda = document.getElementById('checkbox_azienda');
        
        // Sul primo caricamento, se è stato inserito il codice SDI, riapro il campo
        var sdi = document.getElementById('sdi');
        var sdiIsEmpty = this.fieldIsEmpty(sdi);
        if (!sdiIsEmpty) {
            checkIsAzienda.checked = true;
            cntCartBillableFields.style.display = 'block';
        } 

        // Sull'onchange della checkbox, visualizzo i campi per la fatturazione ed disabilito/abilito il bottone di checkout se questi campi sono popolati o meno
        checkIsAzienda.addEventListener('change', (event) => {            
            var checkPrivacy = document.getElementById('check_privacy');
            var sdi = document.getElementById('sdi');
            var sdiIsEmpty = this.fieldIsEmpty(sdi);
            if (event.currentTarget.checked) {
                cntCartBillableFields.style.display = 'block';                                             
                if (sdiIsEmpty) {                     
                    this.setDisabledCheckoutButton();     
                } else {
                    if (checkPrivacy.checked == true) {
                        this.setEnabledCheckoutButton();
                    } else {
                        this.setDisabledCheckoutButton();     
                    }
                }                           
            } else {                
                cntCartBillableFields.style.display = 'none';
                sdi.value = '';
                if (checkPrivacy.checked == true) {
                    this.setEnabledCheckoutButton();
                } else {
                    this.setDisabledCheckoutButton();     
                }
                const body = JSON.stringify({
                    attributes: {
                        'SDI/PEC': null                           
                    }
                });
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
            }
        });
    }

    // Metodo per aggiungere l'attributo custom SDI al carrello
    addAttributesCartSDI() {      
        var self = this;  
        var sdi = document.getElementById('sdi');
        // Durante l'inserimento del codice SDI, effettuo una chiamata Ajax per aggiungere gli attributi custom nel carrello ed abilito il bottone di checkout
        sdi.addEventListener('input', debounce((event) => {
            var checkPrivacy = document.getElementById('check_privacy');
            // Se il campo SDI è vuoto, disabilito il bottone di checkout
            var sdiIsEmpty = this.fieldIsEmpty(sdi);
            if (sdiIsEmpty) {
                this.setDisabledCheckoutButton();     
                const body = JSON.stringify({
                    attributes: {
                        'SDI/PEC': null                           
                    }
                });
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
                return;
            }
            // Il campo SDI è correttamente popolato, posso effettuare la chiamata Ajax per aggiungere gli attributi nel carrello
            const body = JSON.stringify({
                attributes: {
                    'SDI/PEC': event.target.value            
                }
            });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }}).then(function(response) {
                if (checkPrivacy.checked == true) {
                    self.setEnabledCheckoutButton();
                } else {
                    self.setDisabledCheckoutButton();     
                }                
            });
        }, 300))
    }

    // Metodo per controllare se un campo input è vuoto
    fieldIsEmpty(inputElement) {
        if (inputElement.value.length == 0) {             
            return true; 
        }  	
        return false; 
    }

    // Metodo per abilitare il bottone di checkout nella pagina carrello
    setEnabledCheckoutButton() {
        var btnCheckoutCart = document.getElementById('checkout');
        btnCheckoutCart.removeAttribute('disabled', 'disabled');        
    }

    // Metodo per disabilitare il bottone di checkout nella pagina carrello
    setDisabledCheckoutButton() {
        var btnCheckoutCart = document.getElementById('checkout');
        btnCheckoutCart.setAttribute('disabled', 'disabled');        
    }

}

// Definizione del componente
customElements.define('cart-billable-fields', CartBillableFields);